import relationshipService from '../../../services/relationship/RelationshipService';
import enrollmentService from '../../../services/enrollment';
import {captureError} from '../../../utils/log';
import {getSearchValues} from '../../../utils/search';
import {status} from '../../../utils/constant';
import history from '../../../history/history';

// Temp fix to get a fixed number of invitations
const invitationsPageSize = 1000;

export const getSubcontractors = params => new Promise((resolve, reject) => {
  const {queryString = '', page = 0} = getSearchValues(history.location.search);

  const searchParams = [
    params.organisationId,
    status.ACCEPTED,
    params.userId,
    queryString,
    page,
    params.pageSize
  ];

  relationshipService.searchSubcontractorsByQuery(...searchParams)
    .then(({relationships, totalCount}) => {
      const subcontractors = relationships.map(relationship => ({
        ...relationship.subcontractor,
        favorite: relationship.favorite,
        relationshipId: relationship.relationshipId
      }));

      resolve({subcontractors, totalCount});
    })
    .catch(error => {
      captureError('Error while searching for subcontractors', error);
      reject();
    });
});

export function getInvitations(organisationId) {
  return new Promise((resolve, reject) => {
    Promise.all([
      enrollmentService.network.getInvitationsSentToSubcontractor(organisationId),
      relationshipService.getPendingSentInvitations(Number(organisationId), 0, invitationsPageSize)
    ])
      .then(([enrollmentSentInvitations, relationshipSentInvitations]) => {
        const result = [];
        if (enrollmentSentInvitations) {
          result.push(...enrollmentSentInvitations);
        }
        if (relationshipSentInvitations.relationships) {
          result.push(...relationshipSentInvitations.relationships);
        }
        resolve(result);
      })
      .catch(error => {
        captureError('Error while fetching subcontractors sent invitations', error);
        reject();
      });
  });
}
